/**
 * Saves Chat Session
 * @param {ChatSession} newSession
 */
export function saveChatSession(newSession) {
  localStorage.setItem('TD_LC_CHAT_SESSION', JSON.stringify(newSession))
}
